import {styled} from '@mui/material';
import {useTheme} from '@mui/styles';
import React, {useMemo} from 'react';

const Container = styled('div')(({theme}) => ({
  borderBottom: `2px solid ${theme.palette.grey['100']}`,
  borderTop: `2px solid ${theme.palette.grey['100']}`,
  display: 'flex',
  flex: 1,
  width: '100%',

  '& > span': {
    alignItems: 'center',
    display: 'flex',
    flex: 0,
    padding: `0 ${theme.spacing(2)}`,
  }
}));

const Periods = styled('ul')(({theme}) => ({
  display: 'flex',
  flex: 1,
  listStyle: 'none',
  margin: 0,
  padding: `0 ${theme.spacing(2)} 0 0`,
}));

const Period = styled('li')(({theme}) => ({
  borderLeft: `2px solid ${theme.palette.grey['100']}`,
  color: 'var(--period-colour)',
  cursor: 'pointer',
  fontWeight: '700',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,

  '&:last-of-period': {
    borderRight: `2px solid ${theme.palette.grey['100']}`,
  },

  '&.selected': {
    background: 'var(--period-colour)',
    color: theme.palette.common.white,
  }
}));

const Filter = ({period, onChangePeriod}) => {
  const theme = useTheme();
  const periods = useMemo(() => [
    {title: '12 Months', key: '12', colour: theme['palette'].primary.main},
    {title: '6 Months', key: '6', colour: theme['palette'].primary.main},
    {title: '3 Months', key: '3', colour: theme['palette'].primary.main}
  ], [theme]);

  return (
    <Container>
      <span>Displaying:</span>
      <Periods>
        {periods.map(({title, key, colour}, index) => (
          <Period
            key={index}
            className={period === key ? 'selected' : ''}
            style={{'--period-colour': colour}}
            onClick={() => period === key ? null : onChangePeriod(key)}
          >
            {title}
          </Period>
        ))}
      </Periods>
    </Container>
  );
}

export default Filter;
